var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"name","placeholder":"Search...","options":_vm.products,"disabled":_vm.disabled},on:{"search":_vm.onSearch},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}},[_c('template',{slot:"no-options"},[_vm._v(" Start typing to search for a product ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }